import React from 'react'
import '../../styles/4-Skills/Skills.css'
import Video from '../../assets/videos/video-skills.mp4'
import { SiCss3, SiJavascript, SiJquery, SiTypescript, SiReact, SiBootstrap, SiSass, SiGit, SiHtml5} from 'react-icons/si'
import useLanguageContext from '../../hooks/useLanguageContext'

const Skills = () => {

  const languageState = useLanguageContext()

  return (
    <section id='skills'>
      <h2 className='skills__title'>
        {
          languageState ? "Skills" : "Habilidades"
        }
      </h2>
      <div className='skills__content'>
        <article className='content__tecnologies'>
          <ul className='skill-list'>
            <li className='skill'>
              <SiHtml5 className='skill-logo' />
              <div className='skill-separator'></div>
              <h3>HTML</h3>
            </li>
            <li className='skill'>
              <SiCss3 className='skill-logo' />
              <div className='skill-separator'></div>
              <h3>CSS</h3>
            </li>
            <li className='skill'>
              <SiJavascript className='skill-logo' />
              <div className='skill-separator'></div>
              <h3>JAVASCRIPT</h3>
            </li>
            <li className='skill'>
              <SiJquery className='skill-logo' />
              <div className='skill-separator'></div>
              <h3>JQUERY</h3>
            </li>
            <li className='skill'>
              <SiTypescript className='skill-logo' />
              <div className='skill-separator'></div>
              <h3>TYPESCRIPT</h3>
            </li>
            <li className='skill'>
              <SiReact className='skill-logo' />
              <div className='skill-separator'></div>
              <h3>REACT</h3>
            </li>
            <li className='skill'>
              <SiBootstrap className='skill-logo' />
              <div className='skill-separator'></div>
              <h3>BOOTSTRAP</h3>
            </li>
            <li className='skill'>
              <SiSass className='skill-logo' />
              <div className='skill-separator'></div>
              <h3>SASS</h3>
            </li>
            <li className='skill'>
              <SiGit className='skill-logo' />
              <div className='skill-separator'></div>
              <h3>GIT</h3>
            </li>
          </ul>
        </article>
        <article className='content__video'>
          <video src={Video} muted autoPlay loop />
        </article>
      </div>
    </section>
  )
}

export default Skills